import { useState, useEffect, useRef, useCallback } from "react";
import axios from "axios";
import dayjs from "dayjs";
import $ from 'jquery';
import 'magnific-popup';

const StudentAssignment = () => {
    const [form, setForm] = useState({ subject_id: '' });
    const [searchClicked,setSearchClicked] = useState(false);

    const [assignment, setAssignment] = useState([]);
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);

    // Refs to track up-to-date state inside scroll handler
    const offsetRef = useRef(0);
    const loadingRef = useRef(false);
    const hasMoreRef = useRef(true);

    const fetchAssignment = useCallback(async (reset = false) => {
        if (loadingRef.current || (!hasMoreRef.current && !reset)) return;
        
        if (reset) {
            offsetRef.current = 0;
            hasMoreRef.current = true;
            setHasMore(true);
            setAssignment([]);
        }
        
        loadingRef.current = true;
        setLoading(true);

        try {
            const res = await axios.get("/api/student/get-student-assignment", {
                params: { 
                    offset: offsetRef.current,
                    subject_id: form.subject_id || '',
                }
            });

            const newAssignment = res.data.data || [];

            setAssignment((prev) => [...prev, ...newAssignment]);

            if (newAssignment.length < 10) {
                setHasMore(false);
                hasMoreRef.current = false;
            } else {
                offsetRef.current += 10;
            }
        } catch (err) {
            console.error("Error fetching assignment", err);
        }

        setLoading(false);
        loadingRef.current = false;
    }, [form.subject_id]);

    useEffect(() => {
        fetchAssignment(); // Load first 10 assignment
    }, [fetchAssignment]);
    
    const handleSearch = () => {
        setSearchClicked(true);
        fetchAssignment(true); // reset mode
    };
    useEffect(() => {
        if (searchClicked) {
            // Fetch data or trigger animation
        }
    }, [searchClicked]);

    useEffect(() => {
        const handleScroll = () => {
            if (
                window.innerHeight + document.documentElement.scrollTop + 50 >=
                document.documentElement.scrollHeight
            ) {
                fetchAssignment();
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [fetchAssignment]);

    const [subjects, setSubjects] = useState([]);
    useEffect(() => {
        axios.get('/api/student/get-student-subjects')
        .then(res => {
            const data = res.data;
            if (Array.isArray(data)) {
                setSubjects(data);
            } else if (Array.isArray(data.subjects)) {
                setSubjects(data.subjects);
            } else {
                setSubjects([]); // fallback
            }
        })
        .catch(err => {
            console.error(err);
            setSubjects([]); // in case of error
        });
    }, []);

    return (
        <div className="row gy-44">
            <div className="col-xxl-6">
                <div className="card p-0 overflow-hidden position-relative radius-12 h-100">
                    <div className="card-header py-16 px-10 bg-base border border-end-0 border-start-0 border-top-0">
                        <h3 className="mb-0">Assignment</h3>
                    </div>
                    <div className="card-body p-10 pt-10">
                        <div className="mb-3">
                            <div className="row gy-3">
                                <div className="col-8">
                                    <select
                                        className='form-control form-select h-56-px pt-3'
                                        name="subject_id"
                                        value={form.subject_id}
                                        onChange={e => setForm({ ...form, subject_id: e.target.value })}
                                        required
                                        >
                                        <option value="">All Subjects</option>
                                        {Array.isArray(subjects) && subjects.map(y => (
                                            <option key={y.id} value={y.id}>{y.subject_name}</option>
                                        ))}
                                        </select>
                                </div>
                                <div className="col-4">
                                    <button
                                        className="btn btn-primary w-100 h-56-px radius-12"
                                        onClick={handleSearch}
                                    >
                                        Search
                                    </button>
                                </div>
                            </div>
                        </div>
                        {assignment.map((item, index) => (
                            <div key={index} className="notification-card mb-3">
                                <div className="row gy-3">
                                    <div className="col-12">
                                        <label className="form-label">Send Date </label>: {dayjs(`${item.added_datetime}`).format('DD/MM/YYYY hh:mm A')}
                                    </div>
                                </div>
                                <div className="row gy-3">
                                    <div className="col-12">
                                        <label className="form-label">Sended By </label>: {item.User?.first_name} {item.User?.last_name}
                                    </div>
                                </div>
                                <div className="row gy-3">
                                    <div className="col-12">
                                        <label className="form-label">Subject </label>: {item.Subject?.subject_name}
                                    </div>
                                </div>
                                <div className="row gy-3">
                                    <div className="col-12">
                                        <label className="form-label">Assignment Title </label>: {item.assignment_title}
                                    </div>
                                </div>
                                <div className="row gy-3">
                                    <div className="col-12">
                                        <label className="form-label">Description </label>: {item.assignment_description}
                                    </div>
                                </div>
                                <div className="row gy-3">
                                    <div className="col-12">
                                        <label className="form-label">Submission Date </label>: {dayjs(`${item.submission_date}`).format('DD/MM/YYYY')} {dayjs(`1970-01-01T${item.submission_time}`).format('hh:mm A')}
                                    </div>
                                </div>
                                {item.assignment_attachment && (
                                    <div className="row gy-3">
                                        <div className="col-12 text-center">
                                        {(() => {
                                            const fileUrl = `${process.env.REACT_APP_BASE_SITE_URL}/uploads/attachments/${item.assignment_attachment}`;
                                            const ext = item.assignment_attachment.split(".").pop().toLowerCase();
                                            const anchorId = `popup-link-${index}`; // unique ID for each anchor

                                            if (ext === "pdf") {
                                            return (
                                                <button
                                                className="btn btn-primary"
                                                style={{ fontWeight: 700 }}
                                                onClick={() => window.open(fileUrl, "_blank")}
                                                >
                                                View PDF
                                                </button>
                                            );
                                            } else {
                                            return (
                                                <>
                                                {/* Hidden anchor tag that triggers popup */}
                                                <a
                                                    id={anchorId}
                                                    href={fileUrl}
                                                    className="popup-link"
                                                    style={{ display: "none" }}
                                                >
                                                    Open Image
                                                </a>

                                                {/* Visible button that triggers anchor programmatically */}
                                                <button
                                                    className="btn btn-primary"
                                                    style={{ fontWeight: 700 }}
                                                    onClick={() => $(`#${anchorId}`).magnificPopup({ type: 'image', closeOnContentClick: true,image: { verticalFit: true } }).magnificPopup('open')}
                                                >
                                                    View Document
                                                </button>
                                                </>
                                            );
                                            }
                                        })()}
                                        </div>
                                    </div>
                                )}

                            </div>
                        ))}
                        {loading && <p>Loading...</p>}
                        {!hasMore && <p className="error">No more assignment</p>}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StudentAssignment;